import React from 'react';
import { FormControlLabel, Grid, TextField } from 'components/mui';
import styles from './CheckpointEditor.module.css';
import { Radio, RadioGroup } from '@mui/material';
import CheckpointStatusResponse from './CheckpointStatusResponse';
import useCheckpointEditor from 'containers/pages/checklists/hooks/useCheckpointEditor';
import CheckpointDropdownResponse from './CheckpointDropdownResponse';
import initCheckpoint from 'containers/pages/checklists/data/initCheckpoint';
import { cloneDeep } from 'lodash';
import DropdownComponent from './DropdownComponent';

interface CheckpointEditorProps {
	highlightedCheckpoint: Checkpoint;
	setCheckpoints: React.Dispatch<React.SetStateAction<Checkpoint[]>>;
}

const CheckpointEditor = (props: CheckpointEditorProps) => {
	const { highlightedCheckpoint, setCheckpoints } = props;

	const { state, handlers } = useCheckpointEditor(
		highlightedCheckpoint,
		setCheckpoints,
	);

	// Create an array with all the possible values of the union type
	const checkpointResponseTypes: CheckpointResponseTypesTS[] = [
		'Comment',
		'Status',
		'Time',
		'Dropdown',
		'Attachment',
		'Signature',
		'DateTime',
	];

	return (
		<>
			<h2 className={styles.main_title}>
				{highlightedCheckpoint.CheckpointID !== 0
					? 'Edit Checkpoint:'
					: 'Select a checkpoint to edit:'}
			</h2>
			<Grid
				container
				className={`${styles.wrap_sub_container} ${
					state.disabled && styles.blur
				}`}
			>
				<Grid item xs={12} md={12}>
					<TextField
						className={styles.wrap_foo}
						size="small"
						label="Name"
						variant="outlined"
						required
						error={highlightedCheckpoint.Name === ''}
						helperText={
							highlightedCheckpoint.Name === '' &&
							"Checkpoint's name is required"
						}
						value={highlightedCheckpoint.Name}
						onChange={handlers.handleNameChange}
					/>

					<TextField
						className={styles.wrap_foo}
						size="small"
						variant="outlined"
						label="Instructions"
						value={highlightedCheckpoint.Description}
						onChange={handlers.handleDescriptionChange}
						multiline
						maxRows={5}
					/>
				</Grid>
				<hr className={styles.divider_line} />
				<p className={styles.wrap_header_text}>
					What type of response do you want to enable in this
					checkpoint?
				</p>

				<Grid item xs={12} md={12}>
					<RadioGroup
						value={
							highlightedCheckpoint.ResponseType ===
							'DropdownMultiSelect'
								? 'Dropdown'
								: highlightedCheckpoint.ResponseType
						} // Doing this because dropdownMultiSelect is a subset of dropdown (they are essentially the same response types)
						onChange={handlers.handleResponseTypeChange}
						className={styles.response_grid}
					>
						{checkpointResponseTypes.map((value) => (
							<FormControlLabel
								value={value}
								control={<Radio />}
								label={value}
							/>
						))}
					</RadioGroup>
				</Grid>
				{highlightedCheckpoint.ResponseType === 'Comment' && (
					<>
						<DropdownComponent
							dropdowns={highlightedCheckpoint.Dropdowns}
							dropdownType={'noStatusAutoFill'}
							onUpdateDropdown={handlers.handleDropdownChange}
							headerText="Comment Auto-fill Options"
						/>
					</>
				)}

				{highlightedCheckpoint.ResponseType === 'Status' && (
					<CheckpointStatusResponse
						status={
							highlightedCheckpoint?.Status?.length !== 0
								? highlightedCheckpoint?.Status
								: cloneDeep(initCheckpoint.Status)
						}
						onUpdateStatus={handlers.handleStatusChange}
						dropdowns={highlightedCheckpoint?.Dropdowns}
						onUpdateDropdown={handlers.handleDropdownChange}
					/>
				)}
				{(highlightedCheckpoint.ResponseType === 'Dropdown' ||
					highlightedCheckpoint.ResponseType ===
						'DropdownMultiSelect') && (
					<CheckpointDropdownResponse
						dropdowns={
							highlightedCheckpoint?.Dropdowns?.length !== 0
								? highlightedCheckpoint?.Dropdowns
								: cloneDeep(initCheckpoint.Dropdowns)
						}
						responseType={highlightedCheckpoint?.ResponseType}
						onUpdateDropdown={handlers.handleDropdownChange}
						onUpdateResponseType={handlers.handleResponseTypeChange}
					/>
				)}

				<hr className={styles.divider_line} />
			</Grid>
		</>
	);
};
export default CheckpointEditor;
